import React from 'react'
import {
  FacebookIcon,
  FacebookShareButton,
  PinterestIcon,
  PinterestShareButton,
  EmailIcon,
  EmailShareButton,
} from 'react-share'
import InstagramIcon from '@icons/InstagramIcon'
import { INSTAGRAM_URL } from '../../../constants'

interface PostShareButtonsProps {
  url: string
  imgUrl: string
  hashtag: string
  description: string
  title: string
  iconSize: number
  dense?: boolean
}

const PostShareButtons: React.FC<PostShareButtonsProps> = ({
  url,
  imgUrl,
  hashtag,
  description,
  title,
  iconSize,
  dense,
}) => {
  return (
    <div className='flex items-center -mx-5'>
      <span className={dense ? 'px-2' : 'px-15 md:px-5'}>
        <FacebookShareButton className='flex' url={url} hashtag={hashtag}>
          <FacebookIcon size={iconSize} round />
        </FacebookShareButton>
      </span>
      <span className={dense ? 'px-2' : 'px-15 md:px-5'}>
        <PinterestShareButton className='flex' url={url} media={imgUrl} description={description.slice(0, 490) + '...'}>
          <PinterestIcon size={iconSize} round />
        </PinterestShareButton>
      </span>
      <span className={dense ? 'px-2 flex' : 'px-15 md:px-5'}>
        <a className='flex' href={INSTAGRAM_URL} target='_blank'>
          <InstagramIcon className='rounded-2xl' style={{ fontSize: iconSize }} />
        </a>
      </span>
      <span className={dense ? 'px-2' : 'px-15 md:px-5'}>
        <EmailShareButton className='flex' url={url} body={description} subject={title} separator={'\n'}>
          <EmailIcon size={iconSize} round />
        </EmailShareButton>
      </span>
    </div>
  )
}

export default PostShareButtons
